/**
 * List of events used by personal details edit widget
 *
 */
export const personalDetailsEdit = {
  PERSONAL_DETAILS_EDIT_UPDATED: 'personalDetailsEdit.updated',
  PERSONAL_DETAILS_EDIT_EXTERNAL_FLIGHTS_FORM_OPEN: 'personalDetailsEdit.externalFlightsFormOpen',
  PERSONAL_DETAILS_EDIT_EXTERNAL_FLIGHTS_FORM_UPDATED: 'personalDetailsEdit.externalFlightsFormUpdated'
}
